// extracted by mini-css-extract-plugin
export default {"wrapper":"AssistantPage_wrapper__Qz+d4","content":"AssistantPage_content__LSXUY","tabContent":"AssistantPage_tabContent__A20ww"};